import { createContext } from "react";

const SwitchContext = createContext(null);

export default SwitchContext;
